import { useTranslation } from 'react-i18next'

const isWeChat = /MicroMessenger/i.test(navigator.userAgent)

export function QrLoginLandingPage() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-lg font-semibold text-[var(--xr-text-primary)]">{t('qrLogin.title')}</h1>
      <p className="max-w-sm text-sm text-[var(--xr-text-secondary)]">
        {isWeChat ? t('qrLogin.wechat') : t('qrLogin.guidance')}
      </p>
      {isWeChat && (
        <button
          type="button"
          className="rounded-md bg-[var(--xr-accent)] px-4 py-2 text-sm font-medium text-white"
          onClick={() => navigator.clipboard.writeText(window.location.href)}
        >
          {t('qrLogin.copyLink')}
        </button>
      )}
    </div>
  )
}
